function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.3999 4.90039C9.3999 4.34811 8.95219 3.90039 8.3999 3.90039C7.84762 3.90039 7.3999 4.34811 7.3999 4.90039L9.3999 4.90039ZM8.3999 11.2004L8.3999 12.2004L9.3999 12.2004L9.3999 11.2004L8.3999 11.2004ZM4.1999 11.2004L3.1999 11.2004L3.1999 12.2004L4.1999 12.2004L4.1999 11.2004ZM4.1999 9.85832L5.1999 9.85832L4.1999 9.85832ZM7.3999 4.90039L7.3999 11.2004L9.3999 11.2004L9.3999 4.90039L7.3999 4.90039ZM8.3999 10.2004L4.1999 10.2004L4.1999 12.2004L8.3999 12.2004L8.3999 10.2004ZM5.1999 11.2004L5.1999 9.85832L3.1999 9.85832L3.1999 11.2004L5.1999 11.2004ZM5.1999 9.85832C5.1999 7.8901 6.62286 6.21036 8.5643 5.88678L8.2355 3.914C5.32968 4.3983 3.1999 6.91242 3.1999 9.85832L5.1999 9.85832Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.4 11.2002C23.9463 11.2002 25.2 9.94659 25.2 8.40019C25.2 6.8538 23.9463 5.6002 22.4 5.6002C21.8236 5.6002 21.288 5.77432 20.8427 6.07282C20.46 4.9822 19.4213 4.2002 18.2 4.2002C16.9786 4.2002 15.9399 4.9822 15.5572 6.07282C15.1119 5.77432 14.5763 5.6002 14 5.6002C12.4536 5.6002 11.2 6.8538 11.2 8.40019C11.2 9.94659 12.4536 11.2002 14 11.2002",
  stroke: "white",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.2 7V11.2",
  stroke: "white",
  strokeWidth: 2
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M14 8.3999L18.2 11.1999",
  stroke: "white",
  strokeWidth: 2
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M22.4 8.3999L18.2 11.1999",
  stroke: "white",
  strokeWidth: 2
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M8.40005 21.0002C4.95686 19.0896 2.80005 15.417 2.80005 11.2002H25.2C25.2 15.417 23.0432 19.0896 19.6 21.0002",
  stroke: "white",
  strokeWidth: 2
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 8.40015,
  y: 21,
  width: 11.2,
  height: 2.8,
  stroke: "white",
  strokeWidth: 2
});

var SvgSalad = function SvgSalad(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSalad, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/salad.3dca5074.svg";
export { ForwardRef as ReactComponent };